import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './Card.module.scss'

const propTypes = {
  /**
   * Content of the card
   */
  children: PropTypes.node,
  /**
   * Class to override default styles
   */
  className: PropTypes.string,
}

function Card(props) {
  const { children = null, className = '', ...rest } = props ?? {}

  return (
    <div className={clsx(styles.card, className)} {...rest}>
      {children}
    </div>
  )
}

Card.propTypes = propTypes

export default Card
